import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsLoading } from '../../store/slices/common';
import './spinner.scss';

const Spinner = () => {
  const isLoading = useSelector(selectIsLoading);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
